import React, { useEffect, useRef, useContext, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom';

import logo from '../../assets/imgs/icons/user.png';

import { AuthContext } from '../../auth/AuthContext';

import style from '../../assets/styles/ui/botonPerfil.module.css'
import { types } from '../../types/types';

const BotonPerfil = () => {

    const [ mostrarMenu, setMostrarMenu ] = useState( false );
    const dropdown = useRef();

    const { user, dispatch } = useContext( AuthContext );
    const history = useHistory();

    const clickHandler = (event) => {

        if( dropdown.current && dropdown.current.contains(event.target )) {
            return
        }

        setMostrarMenu( false )

    }

    const handleLogout = () => {
        dispatch({ type: types.logout });
        localStorage.removeItem( types.token );
        history.push('/')
    }

    useEffect(() => {
        document.addEventListener('click', clickHandler )

        return () => {
            document.removeEventListener('click', clickHandler )
        }

    }, [])

    return ( user && 
        <div ref={ dropdown } className={ style.botonPerfilDropdown } >

            <div
                className={ style.botonPerfil } 
                onClick={ () => setMostrarMenu(!mostrarMenu)}
            >
                <img src={ logo } alt="" />
                <p> { user.nombre } </p>
            </div>

            <div className={ `${ style.botonPerfilDropdownContent } 
                                    ${ mostrarMenu && style.mostrar}` } >
        
                <ul className={ style.dropdownMenu }>
                    <li>
                        <NavLink to='/organizador/dashboard' >
                            Dashboard
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={`/organizador/${ user._id }`} >
                            Mi sitio
                        </NavLink>
                    </li>
                </ul>
                <hr />

                <button 
                    className={ `${style.dropdownButton} activo bg-danger` }
                    onClick={ () => handleLogout() } > Cerrar sesión </button>
                    
            </div>

        </div>
    )
}

export default BotonPerfil
